/**
 * Selos sobre a foto do produto. Duas formas, ambas do protótipo:
 *  - `pill`  cards novos: "NOVA" em brand-500, rounded-full, text-xs, px-3 py-1
 *  - `mini`  cards usados: "USADA" em gray-800 e "VENDIDA" em red-500,
 *            rounded-sm, text-[10px], px-2 py-1
 */
import type { ReactNode } from 'react'
import { cn } from '../lib/cn.js'

export type TomBadge = 'marca' | 'escuro' | 'vermelho'

const TONS: Record<TomBadge, string> = {
  marca: 'bg-brand-500 text-white shadow-sm',
  escuro: 'bg-gray-800 text-white',
  vermelho: 'bg-red-500 text-white shadow-sm',
}

interface PropsBadge {
  tom: TomBadge
  tamanho?: 'pill' | 'mini'
  children: ReactNode
  className?: string
}

export function Badge({ tom, tamanho = 'pill', children, className }: PropsBadge) {
  return (
    <span
      className={cn(
        'inline-block font-bold',
        TONS[tom],
        tamanho === 'pill'
          ? 'rounded-full px-3 py-1 text-xs'
          : 'rounded-sm px-2 py-1 text-[10px]',
        className,
      )}
    >
      {children}
    </span>
  )
}
